export const HASHTAGS = 'hashtags'
